export default __webpack_public_path__ + "static/media/agent_bg.18c65dd1.jpg";